import BASEURLGESTTOR from '../api/gesttor'
import { cadastrarModelosProcessoPayload, paramsListaModelos, atualizarModeloProcessoPayload } from '../../interfaces/modelosProcessos'


export function novaModeloProcesso (payload: cadastrarModelosProcessoPayload) {
    return BASEURLGESTTOR.post('/modelosprocessos', payload)
} 

export function listarModelosProcessos (params: paramsListaModelos) {
    return BASEURLGESTTOR.get (`/modelosprocessos?termo=${params.termo}&situacao=${params.situacao}`)
}

export function atualizarModeloProcesso (idModelo: string, payload: atualizarModeloProcessoPayload) {
    return BASEURLGESTTOR.patch(`/modelosprocessos?idModeloProcesso=${idModelo}`, payload)
}

export function deletarTarefa (idTarefa: string) {
    return BASEURLGESTTOR.delete(`/modelosprocessos?idTarefa=${idTarefa}`)
}

